import { ConfigurableCard } from "../components/ConfigurableCard";
import { useTemplateContext } from "../provider";
import { VerificationNames } from "shared/types";
import { SwitchWithReadOnlyMode } from "../SwitchWithReadOnlyMode";

export const CriminalReportSlice = () => {
  const { readOnly, template, partnerType, setTemplate } = useTemplateContext();

  if (!template) return null;

  const toggleHideCriminalReport = (toggle: boolean) => {
    const updatedTemplate = {
      ...template,
      verification_schemas: {
        ...template.verification_schemas,
        [partnerType]: {
          ...template.verification_schemas[partnerType],
          [VerificationNames.CriminalReport]: {
            ...template.verification_schemas[partnerType][
              VerificationNames.CriminalReport
            ],
            hide_report: toggle
          }
        }
      }
    };

    setTemplate(updatedTemplate);
  };

  const isHideCriminalReportDisabled = !Boolean(
    template.verification_schemas[partnerType][VerificationNames.CriminalReport]
  );

  return (
    <ConfigurableCard title="General settings">
      <SwitchWithReadOnlyMode
        checked={Boolean(
          template.verification_schemas[partnerType][
            VerificationNames.CriminalReport
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          ]?.hide_report
        )}
        label={
          <>
            <p className="text-content-1000 text-sm font-medium">
              Hide criminal report until confirmation of conditional offer
            </p>
            <p className="text-content-400 font-normal text-sm mt-1">
              You will need to click the button to confirm that the applicant is
              conditionally approved
            </p>
          </>
        }
        onChange={(v) => toggleHideCriminalReport(v)}
        disabled={isHideCriminalReportDisabled}
        readOnly={readOnly}
      />
    </ConfigurableCard>
  );
};
